import * as React from 'react';
import { useContext, useState } from 'react';
import { Grid } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { AuthContext } from './_auth/AuthContext';
import { useHistory } from 'react-router-dom';
import { ILoginCreds } from './_types/user';
import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Login as LoginService } from './_service/auth';
import { NavigationContext } from './_navigation/NavigationContext'
import carWashLoading from './carwash.gif'
interface Props {

};


const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  loading: {
    'justify-content': 'center',
    'align-items': 'center',
  }

}));

const Login: React.FC<Props> = (prop: Props) => {

  const { user, setUser } = useContext(AuthContext);
  const [cred, setCred] = useState<ILoginCreds>({ token: "", credential: "" });
  const { nav, setNav } = useContext(NavigationContext);
  const [loadingScreen, setLoadingScreen] = useState<boolean>(false);

  let history = useHistory();
  const classes = useStyles();

  // fuck'n hell this is awesome.  When user is changed, which can be done by 
  // anything in the AuthContext context (though is only done on app startup)
  // this effect will occur.
  React.useEffect(() => {

    if (user.authorized === true) {
      history.push(user.initialPath || `/`);
    }
  }, [user]);

  const loginForm = async () => {

    //Jesse: I plan to add in a login loading screen because this is getting a bit not great
    setLoadingScreen(true);

    let loggedInuser = await LoginService(cred);
    if (loggedInuser) {
      setUser(loggedInuser);
      setNav({ ...nav, open: true });
      setLoadingScreen(false);
    } else (
      //create an error window here
      console.log('it did not work')
    )

  };

  if (loadingScreen === true) {
    return (
      <>
        <div className={classes.paper}>
          <div>Loading!</div>

          <Typography component="h1" variant="h5">
            Loading!
          </Typography>

          <img src={carWashLoading} alt="loading..." />
        </div>

      </>
    )
  }


  // return (
  //     <Grid container direction="row" justify="flex-start" alignItems="stretch">
  //           <Grid item>
  //             Login <b>{process.env.REACT_APP_API_URL}</b>

  //           </Grid>
  //     </Grid>
  // )
  //! Jesse this checks cookie if there I believe cookies.remove() might be useful
  if (!user.fromCookie) {
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <form className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              value={cred.token}
              onChange={(val: React.ChangeEvent<HTMLInputElement>) => setCred({ ...cred, token: val.target.value } as ILoginCreds)}
              autoFocus
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              value={cred.credential}
              onChange={(val: React.ChangeEvent<HTMLInputElement>) => setCred({ ...cred, credential: val.target.value } as ILoginCreds)}
              autoComplete="current-password"
            />
            <Button
              type="button"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={loginForm}
            >
              Sign In
            </Button>
            <Grid container>
              <Grid item xs>
                <Link href="#" variant="body2">
                  Forgot password?
                </Link>
              </Grid>

            </Grid>
          </form>
        </div>
      </Container>
    );
  } else {
    return <div />
  }


}





export default Login;